<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-10 17:45:48
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-07-24 09:57:29
 * @Description: 公告列表
 -->
<template>
  <div class="list-wrapper" v-loading="loading">
    <ul v-if="noticeList.length > 0">
      <li class="list-item" v-for="(item, index) in noticeList" :key="index">
        <router-link :to="`content/${item.noticeid}`" class="title">{{ item.title }}</router-link>
        <p class="date">{{ item.u_time }}</p>
      </li>
    </ul>
    <div class="no-data" v-else>
      暂无数据
    </div>
  </div>
</template>
<script>
export default {
  name: 'announcement',
  data() {
    return {
      noticeList: [],
      loading: false
    };
  },
  created() {
    this.requestList();
  },
  methods: {
    async requestList() {
      try {
        this.loading = true;
        const res = await this.$http.post('/cg/commonRequest', {
          method: 'pinfo.notice.list',
          // token:
          //   'fc2aB1JTBVEICFIGBgJSVVUGVAJSUFIED1xSAFcHBlUICFcOa1FXBQFZAVcCUQZSVAYGAAVQB1MPCgcOVQUEBAIBBQRaagdRCQFPBgFMAQAQBlIOAwUOBA4wBA',
          page: 1,
          terminal: 4
        });
        if (res.code === 200) {
          this.noticeList = res.data;
          this.noticeList.forEach(x => {
            x.u_time = x.u_time.split(' ')[0];
          });
          this.loading = false;
        } else {
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.list-wrapper {
  padding: 20px;
  .list-item {
    display: flex;
    justify-content: space-between;
    padding: 20px 20px;
    border-bottom: 1px dashed #ccc;
    .title {
      cursor: pointer;
    }
  }
  .no-data {
    text-align: center;
    font-size: 30px;
    line-height: 300px;
    color: #ccc;
    background: #fff;
  }
}
</style>
